/**
 * Small in-tab event surface for call UI (ringtone, clear active call refs).
 * Registered by provider audio bridges; consumed by actions and shared call UI.
 */
export default function createCallUiEvents() {
  /** @type {(() => void)|null} */
  let stopRingtoneHandler = null;
  /** @type {(() => void)|null} */
  let clearCallReferencesHandler = null;

  return {
    registerStopRingtone(handler) {
      stopRingtoneHandler = typeof handler === 'function' ? handler : null;
    },
    registerClearCallReferences(handler) {
      clearCallReferencesHandler = typeof handler === 'function' ? handler : null;
    },
    stopRingtone() {
      stopRingtoneHandler?.();
    },
    clearCallReferences() {
      clearCallReferencesHandler?.();
    }
  };
}
